<template><!-- 派送AJD重算 -->
  <el-dialog
    :title="recalculationType === 1 ? $t('receivablePayable.LargeItemRecalculation') : $t('receivablePayable.RecalculateSmallParcels')"
    :visible.sync="isShow"
    width="600px"
    @close="onClose"
  >
    <el-form
      ref="ajdRuleForm"
      :model="ajdRuleForm"
      :rules="adjRules"
      class="demo-ruleForm"
      label-position="top"
      size="small"
    >
      <template v-if="!recalculationType">
        <!--周期-->
        <el-form-item :label="$t('receivablePayable.cycle')+'：'" prop="cycle">
          <el-select
            v-model="ajdRuleForm.cycle"
            :placeholder="$t('operationCenter.PleaseSelect')"
            clearable
            filterable
            size="small"
            style="width: 100%;"
          >
            <el-option
              v-for="(item,index) in periodList"
              :key="item.label"
              :label="item.label"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <!--派送员-->
        <el-form-item :label="$t('orderCenterCont.deliveryPerson')+'：'" prop="dispatcherList">
          <el-select
            v-model="ajdRuleForm.dispatcherList"
            :multiple-limit="10"
            :placeholder="$t('operationCenter.Only10AreDisplayed')"
            :remote-method="getDeliveryPage"
            clearable
            filterable
            multiple
            remote
            :loading="loading"
            size="small"
            style="width: 100%;"
          >
            <el-option
              v-for="item in deliveryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </template>
      <!--      日期-->
      <el-form-item
        v-if="recalculationType === 1"
        :label="$t('operationCenter.date')+'：'" prop="date"
      >
        <el-date-picker
          v-model="ajdRuleForm.date"
          style="width: 100%"
          type="datetimerange"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
          :range-separator="$t('operationCenter.to')"
          :start-placeholder="$t('operationCenter.startDate')"
          :end-placeholder="$t('operationCenter.endDate')"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleDateChange"
        />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button size="small" @click="isShow = false">{{ $t('basicData.Cancel') }}</el-button>
      <el-button size="small" type="primary" @click="saveReCalculate">{{ $t('basicData.determine') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { collectDriverQueryCourier } from '@/api/logisticsOrders';
import { filterAndFormatData, generatePeriods } from './utils';

const QUERY = {
  pageNumber: 1,
  pageSize: 10,
  params: {
    deliveryManName: ''
  }
};

export default {
  props: {
    recalculationType: {
      type: [Number, String],
      default: 2
    }
  },

  data() {
    return {
      isShow: false,
      loading: false, // 派送人加载
      periodList: [], // 周期
      deliveryList: [], // 派送员下拉
      ajdRuleForm: {
        cycle: '', // 周期
        dispatcherList: [], // 派送员
        date: [] // 日期
      },
      adjRules: {
        cycle: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: 'blur' }
        ],
        dispatcherList: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: 'blur' }
        ],
        date: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: 'change' }
        ]
      },
      // 临时存储选择的开始日期的时间戳
      pickerMinDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 当用户选择了第一个日期（minDate）时，设置基准时间
          if (minDate) {
            this.pickerMinDate = minDate.getTime();
          } else {
            // 当选择清空时，重置
            this.pickerMinDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果还没选第一个日期，不做限制
          if (!this.pickerMinDate) {
            return false;
          }

          // 一天的毫秒数
          const oneDayTime = 24 * 60 * 60 * 1000;

          // 计算限制范围
          // 最早可选时间：基准时间 - 31天
          const minTime = this.pickerMinDate - 30 * oneDayTime;
          // 最晚可选时间：基准时间 + 30天
          const maxTime = this.pickerMinDate + 31 * oneDayTime;

          // 禁用不在 [minTime, maxTime] 范围内的日期
          return (
            time.getTime() < minTime ||
            time.getTime() > maxTime
          );
        }
      }
    };
  },

  created() {
    const obj = {
      oneTitle: this.$t('receivablePayable.cycle'),
      twoTitle: this.$t('receivablePayable.cycle'),
      generationCycle2Date: 1, // 1号生成上个月周期2
      generationCycle1Date: 16 // 16号生成本月周期1
    };

    this.periodList = generatePeriods(8, obj).reverse();
  },

  methods: {
    // 打开
    open() {
      this.isShow = true;
      this.$refs.ajdRuleForm.resetFields();

      this.getDeliveryPage();
    },

    /**
     * @description 关闭
     * @param {boolean} isBool 是否向上传递消息
     * @param {object} query 重算传递的参数
     */
    onClose(isBool, query) {
      this.isShow = false;
      if (isBool) {
        this.$emit('submit', query);
      }
    },

    /**
     * @description 派件AJD重算保存
     */
    saveReCalculate() {
      this.$refs.ajdRuleForm.validate(valid => {
        if (!valid) { return; }
        const query = {
          pageNumber: 1,
          pageSize: 10,
          params: {
            businessType: 3, // 业务类型3为派送
            operationMode: 0, // 运营模式0为 AJD
            payableType: 3, // 账单类型3为 AJD
            reCalculatePriceSource: 4,
            cargoType: this.recalculationType
          }
        };
        const { cycle, dispatcherList: list, date } = this.ajdRuleForm;
        if (this.recalculationType) {
          if (date.length > 0) {
            query.params.ajdReCalculateStartTime = date[0];
            query.params.ajdReCalculateEndTime = date[1];
          }
        } else {
          const { years, period } = this.periodList[cycle];
          query.params.years = years;
          query.params.cycle = period;
          query.params.dispatcherList = filterAndFormatData(list);
        }

        setTimeout(() => {
          this.onClose(true, query);
        }, 100);
      });
    },

    /**
     * 获取派送员
     * @param {string} name
     */
    getDeliveryPage(name = '') {
      if (name && (typeof name === 'string')) {
        QUERY.params.deliveryManName = name;
      }
      this.deliveryList = [];
      this.loading = true;
      collectDriverQueryCourier(QUERY, false).then(res => {
        if (res.code === 200) {
          // this.deliveryList = res.data || [];
          this.deliveryList = (res.data || []).map(itme => {
            const { deliveryManName, expressId, supplierId } = itme;

            const value = expressId ? '1:' + deliveryManName + ':' + expressId : '2:' + deliveryManName + ':' + supplierId;
            const obj = {
              label: deliveryManName,
              value
            };
            console.log(obj);
            return Object.freeze(obj);
          });
          console.log(this.deliveryList, 'AJD');
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    handleDateChange(val) {
      // 当用户手动删除输入框内容或组件内部清空时，确保重置 pickerMinDate
      if (!val || val.length === 0) {
        this.pickerMinDate = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
